import { useNavigate } from "react-router-dom";
import { PlayIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import SimpleLoader from "../../components/Loader/SimpleLoader";

const getYoutubeThumbnail = (link) => {
  const match = link?.match(/(?:youtu\.be\/|v=)([a-zA-Z0-9_-]{11})/);
  return match
    ? `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`
    : "https://via.placeholder.com/640x360/674DA2/ffffff?text=Видео";
};

const VideoCard = ({ video, index }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const thumbnail = getYoutubeThumbnail(video.link);

  return (
    <div
      onClick={() => navigate(`/erkin-oiyn/${video.uuid}`)}
      className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transform transition-all duration-500 hover:-translate-y-2 cursor-pointer"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      {/* Hover overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" />

      {/* Play button */}
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
        <div className="bg-white/90 backdrop-blur-sm rounded-full p-4 transform scale-0 group-hover:scale-100 transition-transform duration-300">
          <PlayIcon className="w-8 h-8 text-[#674da2] fill-current" />
        </div>
      </div>

      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden bg-gradient-to-br from-purple-100 to-purple-50">
        {!imageLoaded && (
          <div className="absolute inset-0 flex items-center justify-center">
            <SimpleLoader className="w-8 h-8" />
          </div>
        )}
        <img
          src={thumbnail}
          alt={video.label}
          onLoad={() => setImageLoaded(true)}
          className={`w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ${
            imageLoaded ? "opacity-100" : "opacity-0"
          }`}
        />
      </div>

      {/* Label */}
      <div className="relative p-4 bg-white">
        <h3 className="font-bold text-gray-900 text-base mb-2 line-clamp-2 group-hover:text-[#674da2] transition-colors">
          {video.label || "Еркін ойын"}
        </h3>
      </div>
    </div>
  );
};

export default VideoCard;
